import Cookies from 'js-cookie';

export function setAccessTokenInCookie(val: string) {
  const jsCookies = Cookies.withConverter({
    write: (value) => value as string,
  });
  // legacy token name
  jsCookies.set('Authorization', val);
  // token name
  jsCookies.set('userToken', val);
}

export function getAccessTokenInCookie() {
  return Cookies.get('userToken') || Cookies.get('Authorization');
}
